import { ThreadMessage } from '@assistant-ui/core';

const TITLE_LENGTH = 80;

export const threadTitleFrom = (
  messages: readonly ThreadMessage[],
): string | undefined => {
  const first = messages.find((message) => message.role === 'user');
  if (!first) {
    return undefined;
  }
  const text = first.content
    .flatMap((part) => (part.type === 'text' ? [part.text] : []))
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text) {
    return undefined;
  }
  return text.length <= TITLE_LENGTH
    ? text
    : `${text.slice(0, TITLE_LENGTH - 1).trimEnd()}…`;
};
